var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentEditBlockSlideshowComponent,{tag:"Component",attrs:{"start-tab-id":_vm.startTabId},on:{"close":_vm.closeEditBlockSlideshowComponent}})}
var staticRenderFns = []

export { render, staticRenderFns }